import React from 'react';
import { Chip } from '@mui/material';
import classNames from 'classnames';
import { XClose } from '@diamond-design/icons';
import styles from './Tag.module.scss';
export const Types = [
    'gray',
    'warning',
    'primary',
    'error',
    'success',
];
export const Sizes = ['sm', 'md', 'lg'];
export const iconSize = {
    sm: 12,
    md: 14,
    lg: 16,
};
const Tag = ({ label, size = 'md', type = 'primary', iconLeft: IconLeft, iconRight: IconRight, onClick, onDelete, }) => {
    const isDefaultCloseIcon = !IconRight && !IconLeft && onDelete;
    const className = classNames({
        [styles[`tag_${type}`]]: true,
        [styles.increaseSvgStrokeWidth]: isDefaultCloseIcon,
        [styles.increaseSvgMarginLeft]: IconLeft && label,
        [styles.icon_only]: !label,
        [styles[`${size}_label`]]: true,
    });
    const iconSizeProps = {
        height: iconSize[size],
        width: iconSize[size],
    };
    const IconLeftReact = IconLeft && React.createElement(IconLeft, Object.assign({}, iconSizeProps));
    const IconRightReact = IconRight && React.createElement(IconRight, Object.assign({}, iconSizeProps));
    return (React.createElement(Chip, { className: className, label: label, onClick: onClick, onDelete: onDelete || (IconRight ? () => null : undefined), icon: IconLeftReact, deleteIcon: IconRightReact || (React.createElement(XClose, { height: iconSize.sm, width: iconSize.sm, strokeWidth: 4 })) }));
};
export default Tag;
